import { inject, InjectionKey, ref, toRaw } from 'vue'

export type NotificationType = 'success' | 'warn' | 'error'

export interface Notification {
  id: number
  message: string
  type?: NotificationType
}

export interface NotificationStore {
  readonly list: Notification[]
  push: (message: string, type?: NotificationType) => void
}

export const generateNotificationStore = () => {
  const originalTitle = document.title
  let id = 0
  const _list = ref<Notification[]>([])
  const push = (message: string, type?: NotificationType) => {
    if (_list.value.length >= 100) return // limit
    id++
    const data = { id, message, type }
    _list.value.push(data)
    document.title = message
    setTimeout(() => {
      const i = _list.value.findIndex(v => toRaw(v) === data)
      if (i === -1) return
      _list.value.splice(i, 1)
      if (!_list.value.length) document.title = originalTitle
    }, 5000)
  }
  return {
    get list () {
      return _list.value
    },
    push
  }
}

export const notificationStoreKey: InjectionKey<NotificationStore> = Symbol()

export const useNotificationStore = (): NotificationStore => {
  const notificationStore = inject(notificationStoreKey)
  if (!notificationStore) throw Error('Could not inject notificationStore')
  return notificationStore
}
